export const USER_PROFILE_NOT_FOUND = {
    code: '404_user_profile_not_found',
    message: 'user profile not found'
};
